import { useQuery } from "@tanstack/react-query";
import userGlobalFilterService from "../../../services/userService/userGlobalFilterService";
import { UserGlobalFilter } from "../../../models/UserModel/UserGlobalFilter";
import { CACHE_KEY_GETALLUSERGLOBALFILTER } from "../../../utils/constants";

const useGetAllUserGlobalFilters = (userId: string) =>
  useQuery<UserGlobalFilter[], Error>({
    queryKey: [CACHE_KEY_GETALLUSERGLOBALFILTER, userId],
    queryFn: () => userGlobalFilterService.GetAll(userId),
    initialData: [],
    enabled: !!userId,
  });

export default useGetAllUserGlobalFilters;
